const initialState = {
	activeWorkspace:null
}
const reducer =(state = initialState,action) =>{
	switch(action.type){
		case 'WORKSPACE_CHANGED': return {activeWorkspace:action.value}
		default : return state;
	}

}

export default reducer;



